import minusIcon from 'mui/assets/icons/minus-icon.svg';
import plusIcon from 'mui/assets/icons/plus-icon.svg';
import { renderTypographyStyles } from 'mui/base/utils';
const BaseCardsStyles = ({ theme }) => `
  box-shadow: ${theme.DS_shadows.priceCard};
  border: ${theme.DS_border.priceCard};
  background-color: ${theme.DS_palette.primary.white};
`;

export const sharedBaseCardsStyles = ({ theme }) => `
  ${BaseCardsStyles({ theme })};
  border-radius: ${theme.DS_border.radius.priceCard};
`;

export const sharedInfoCardsStyles = ({ theme }) => `
   ${BaseCardsStyles({ theme })}
   border-radius: ${theme.DS_border.radius.highlighted};
   padding: ${theme.DS_spacing(['md'])};
   ${theme.breakpoints.up('lg')}{
     border-radius: ${theme.DS_border.radius.priceCard};
     padding: ${theme.DS_spacing(['xl'])};
   }
   
`;

export const sharedHoverCardsStyles = ({ theme }) => `
  box-shadow: ${theme.DS_shadows.cardsHover};
  background-color: ${theme.DS_palette.primary.white};
`;

export const ListItemStyles = ({ theme, $plus, $minus }) => `
      margin: 0;    
      border-radius: 94px;
      list-style-type: none;
       background-color: ${$plus || $minus ? `transparent` : `${theme.DS_palette.background.light}`};
      :first-of-type{
       background-color: ${
         $plus
           ? `${theme.DS_palette.label.bgColor}`
           : $minus
           ? `${theme.DS_palette.tag.bgColor}`
           : `${theme.DS_palette.background.light}`
       };
          
          }
      
          p:before{
          position: absolute;
          display: block;
          border-radius: 100%;
          top: 50%;
          transform: translateY( -50%);
          width: 32px;
          height: 32px;
          left: ${theme.DS_spacing(['xxs'])};
          content: ${$plus ? `url(${plusIcon})` : $minus ? `url(${minusIcon})}` : `url(${plusIcon})`};
      }
      
     > p {
       font-weight: 700;
       margin-left: 55px !important;
       margin-right:  ${theme.DS_spacing(['xxs'])} !important;
       padding: ${theme.DS_spacing(['xxs'])} ${theme.DS_spacing(['sm'])} ${theme.DS_spacing([
  'xxs',
])} ${theme.DS_spacing(['xxs'])} !important;
       line-height: ${theme.DS_spacing(['md'])}  !important;
    }
    
      
    
   ${theme.breakpoints.up('lg')} {
      > p {
       padding: 12px !important;
         margin-left: 40px;
          line-height: ${theme.DS_spacing(['lg'])} !important;
      } 
    }
`;
export const ListCardsStyles = ({ theme }) => `
  ${sharedBaseCardsStyles({ theme })};

  margin: ${theme.DS_spacing(['md'])};
  position: relative;
  ul{
    margin: ${theme.DS_spacing(['xs'])} 0 ${theme.DS_spacing(['md'])};
    padding-left: 0;
  }

  padding: ${theme.DS_spacing(['sm'])};


 ${theme.breakpoints.up('md')} {
     padding: ${theme.DS_spacing(['lgx'])};

    }
    
   ${theme.breakpoints.up('lg')} {
   ul{
       margin: ${theme.DS_spacing(['lg'])} 0 ${theme.DS_spacing(['md'])};
    }
    padding: ${theme.DS_spacing(['xl'])};
 
    }
    li {
     ${ListItemStyles({ theme })};
    }
  
`;

export const underlineAsSmallText = ({ theme }) => `
  u {
    ${renderTypographyStyles(theme.typography.DS_copySmallRegular)};
    text-decoration: none;
    padding-bottom: 5px;
  }
`;
